import React, { Fragment, useState } from "react";
import { Form, Label, Segment } from "semantic-ui-react";
import { LoginContainer } from "./shared/components/styled/login";
import Header from "./shared/components/header/index";
import { getCookies } from "./shared/utilities/auth";
import { getAccess } from "./server/index";
import { Event } from "./analytics";

const LoginPage = ({ authorize, auth, ga, ...props }) => {
  const { username: _username, password: _password } = getCookies();
  const [username, setUsername] = useState(_username);
  const [password, setPassword] = useState(_password);
  const [_message, setMessage] = useState(null);

  return (
    <Fragment>
      <Header />
      <LoginContainer>
        <Segment raised>
          <Label attached="top" content={"Login to Demo Homepage"} />
          <Form
            onSubmit={async function() {
              const { success, message, profile } = await getAccess({
                username,
                password
              });

              const userSplit = username.replace(".com", "").split("@");
              const userString = `${userSplit[0]} (at) ${userSplit[1]}`;

              if (success) {
                let expireDate = new Date();
                expireDate.setMonth(expireDate.getMonth() + 2);
                Event(
                  "USER_LOGIN",
                  `Successful login by ${userString}`,
                  "SUCCESSFUL_LOGIN"
                );

                document.cookie = `MDO_User=${username};`;
                document.cookie = `MDO_Password=${password};`;

                authorize({ access: true, verified: true, profile });
                setMessage(null);
              } else {
                Event(
                  "USER_LOGIN",
                  `Unsuccessful login by ${userString}`,
                  "UNSUCCESSFUL_LOGIN"
                );
                setMessage(`Unable to Login`);
              }
            }}
          >
            <Form.Input
              label="Email"
              onChange={(ev, { value }) => setUsername(value)}
              defaultValue={username}
            />
            <Form.Input
              label="Password"
              onChange={(ev, { value }) => setPassword(value)}
              type="password"
              defaultValue={password}
            />

            <Form.Button type="submit" content="Submit" />
          </Form>
          {_message}
        </Segment>
      </LoginContainer>
    </Fragment>
  );
};

export default LoginPage;
